module.exports = __webpack_public_path__ + "img/photo-09.0e60593a.jpg";